import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { useNavigate } from "react-router-dom";

const NavigatorBar = (props) => {
  const navigate = useNavigate();
  const handleClick = (event) => {
    //event.preventDefault();
    //navigate(event.target);//bug - using whole elenment which caused circular structure error
    //fixed body navigation bar issue on clicking - Uncaught TypeError: Converting circular structure to JSON
    const targetUrl = event.target.getAttribute('href');
    if (targetUrl) {
      event.preventDefault(); // Prevent default anchor behavior
      navigate(targetUrl);    // Navigate to the href value
    }
  };

  return (
    <div role="presentation" onClick={handleClick}>
      <Breadcrumbs aria-label="breadcrumb">
        {props.content ? (
          <props.navigatorHtml />
        ) : (
          <Link underline="none">&nbsp; </Link>
        )}
      </Breadcrumbs>
    </div>
  );
};

export default NavigatorBar;
